import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import NotificationsPage from "../../pages/Notifications/NotificationsPage";
import { useAuth } from "../../contexts/AuthContext";

const Layout = ({
  children,
  notificationsOpen, // receives from App.js
  onToggleNotifications, // receives from App.js
  selectedClient, // receives from App.js
  onClientSelect, // receives from App.js
  user, // receives from App.js
}) => {
  const location = useLocation();
  const { isStaffUser } = useAuth();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  // Allow child pages to request sidebar collapse via a custom event
  useEffect(() => {
    const handler = () => setCollapsed(true);
    window.addEventListener("collapse-sidebar", handler);
    return () => window.removeEventListener("collapse-sidebar", handler);
  }, []);

  // Allow child pages to request sidebar expand via a custom event
  useEffect(() => {
    const handler = () => setCollapsed(false);
    window.addEventListener("expand-sidebar", handler);
    return () => window.removeEventListener("expand-sidebar", handler);
  }, []);

  const [dark, setDark] = useState(false);
  
  // Determine mode based on user role and current location
  const getMode = () => {
    // If user is not superadmin, always use "client" mode
    if (!isStaffUser()) {
      return "client";
    }
    // If superadmin, check current location
    if (location.pathname.startsWith("/client")) {
      return "client";
    }
    return "superadmin";
  };
  
  // Initialize mode - for normal users, always "client", for superadmin check location
  const initialMode = isStaffUser()
    ? (location.pathname.startsWith("/client") ? "client" : "superadmin")
    : "client";
  
  const [mode, SetMode] = useState(initialMode);
  
  // Update mode when location changes (only for superadmin users)
  useEffect(() => {
    // For normal users, mode should always be "client"
    if (!isStaffUser()) {
      if (mode !== "client") {
        SetMode("client");
      }
      return;
    }
    
    // For superadmin, update based on location
    const newMode = location.pathname.startsWith("/client") ? "client" : "superadmin";
    if (newMode !== mode) {
      SetMode(newMode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, isStaffUser]);

  // Dark mode
  useEffect(() => {
    if (dark) document.body.classList.add("dark-mode");
    else document.body.classList.remove("dark-mode");
  }, [dark]);

  const isMobile = typeof window !== "undefined" && window.innerWidth <= 992;

  return (
    <>
      {/* SIDEBAR */}
      <Sidebar collapsed={collapsed} open={!isMobile || mobileOpen} onClose={() => setMobileOpen(false)} onToggleCollapse={() => setCollapsed(c => !c)} mode={mode} notificationsOpen={notificationsOpen} onCloseNotifications={onToggleNotifications} selectedClient={selectedClient} />

      <div
        style={{
          marginLeft: !isMobile ? (collapsed ? 78 : 240) : 0,
          transition: "margin-left .25s",
        }}
      >
        {/* HEADER */}
        <Header
          isDark={dark}
          toggleDark={() => setDark(!dark)}
          onToggleSidebar={() => (isMobile ? setMobileOpen(true) : setCollapsed(!collapsed))}
          notificationsOpen={notificationsOpen}
          onToggleNotifications={onToggleNotifications}
          selectedClient={selectedClient}
          onClientSelect={onClientSelect}
          mode={mode}
          SetMode={(e) => SetMode(e)}
          user={user}
        />

        {/* MAIN CONTENT */}
        <main className="p-md-4" style={{ minHeight: "100vh" }}>
          {notificationsOpen ? <NotificationsPage selectedClient={selectedClient} onClose={onToggleNotifications} /> : children}
        </main>
      </div>
    </>
  );
};

export default Layout;
